import PageContainer from '@/views/base/page.vue'
export default [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '*',
    redirect: '/home',
  },
  {
    path: '/login',
    component: () => import('@/views/base/login.vue'),
    meta: { title: '登录', keepAlive: false, needAuth: false }
  },
  {
    path: '/index',
    component: PageContainer,
    children: [
      {
        path: '/content-webview',
        component: () => import('@/views/base/content-webview.vue'),
        meta: { title: 'webview', keepAlive: false, needAuth: false }
      }
    ]
  }
]
